/* eslint-disable react/prop-types */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-cycle
import { Error } from '@nextgen/frontend-components-organisms';
import { useTranslations } from '../../hooks/IntlProvider/useTranslations';

const AppErrorRenderer = ({
  displayErrorButtonId,
  displayErrorHeadingId,
  displayErrorLinkId,
  displayErrorMessageId,
  error,
  errorMessageId,
  headingId,
  homepageButtonId,
  link,
  linkId,
  resetErrorBoundary
}) => {
  const { messages } = useTranslations('errorPage');

  useEffect(() => {
    document.addEventListener('click', resetErrorBoundary, false);

    return () => {
      document.removeEventListener('click', resetErrorBoundary, false);
    };
  });

  return (
    <div>
      <Error
        errorMessage={messages[displayErrorMessageId] || messages[errorMessageId]}
        buttonText={messages[displayErrorButtonId] || messages[homepageButtonId]}
        headingText={messages[displayErrorHeadingId] || messages[headingId]}
        link={link}
        linkText={messages[displayErrorLinkId] || messages[linkId]}
        errorReason={error.message}
      />
    </div>
  );
};

AppErrorRenderer.defaultProps = {
  displayErrorLinkId: 'error.displayErrorLink',
  displayErrorButtonId: 'error.displayErrorButton',
  displayErrorHeadingId: 'error.displayErrorHeading',
  displayErrorMessageId: 'error.displayErrorMessage',
  errorMessageId: 'error.message',
  headingId: 'error.headingText',
  homepageButtonId: 'error.homepageButtonText',
  link: '/content/contact',
  linkId: 'error.linkText'
};

AppErrorRenderer.propTypes = {
  displayErrorLinkId: PropTypes.string,
  displayErrorButtonId: PropTypes.string,
  displayErrorHeadingId: PropTypes.string,
  displayErrorMessageId: PropTypes.string,
  errorMessageId: PropTypes.string,
  headingId: PropTypes.string,
  homepageButtonId: PropTypes.string,
  link: PropTypes.string,
  linkId: PropTypes.string,
  resetErrorBoundary: PropTypes.func.isRequired
};

export default AppErrorRenderer;
